var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video-background',{style:({height: _vm.height}),attrs:{"src":_vm.$api.getImageUrl(_vm.src) + '&_ignore=.mp4'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }